<template lang="pug">

.subtitles
  ul
    //- transition-group(name='line')
    li(
      v-for="(line, index) in lines"
      :key="index"
      v-show="currTime >= line.startTime && currTime < line.endTime"
    )
      .line(v-for="l in line.text") {{ l }}

</template>

<script>
import Raf from 'src/helpers/Raf'
import SoundService from 'src/services/SoundService'
import subs from 'src/components/manifests/subtitles'

//console.log(1111111, subs)

export default {
  name: 'subtitles',
  components: {

  },
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      currTime: 0,
    }
  },
  computed: {
    lines() {
      return subs[this.id]
    },
  },
  mounted() {
    this.media = SoundService.get(this.id)

    Raf.add(this.update)
  },
  beforeDestroy() {
    Raf.remove(this.update)
  },
  methods: {
    update() {
      if (!this.media) return
      this.currTime = this.media.currentTime
    },
  },
  watch: {
    id(val){
      this.media = SoundService.get(val)
    }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

.subtitles
  width: 100%
  height: 100%
  text-align: center
  pointer-events: none


li
  +full()
  +flex-center()

  .line
    display: inline-block
    white-space: pre
    text-shadow: 2px 2px 6px rgba(0,0,0,0.5)
    line-height: 1.3
    // font-weight: bold

// .line-enter-active
//   transition: all 0.1s $easeOutQuad 0s

// .line-enter
//   opacity: 0

// .line-leave-active
//   opacity: 0
//   transition: all 0.1s $easeOutQuad 0s

</style>
